export function getErrors(errors) {
    // Inizializzo una stringa vuota
    let result = [];
    // Giro le chiavi di errore
    _.forIn(errors, function(value, key) {
        // Per ogni chiave prendo gli errori
        let errorArray = (_.flattenDeep(value));
        // Li appendo agli errori
        errorArray.forEach(element => {
            result.push(element);
        })
    });
    //Torno gli errori
    return result;
};

export function parseError(error) {
    let errorArray = getErrors(error.response.data.errors);
    Swal.fire({
        title: 'Attenzione!',
        html: errorArray.join('<br />'),
        type: 'error',
        showConfirmButton: true
    });
}

export function parseGenericException() {
    Swal.fire({
        text: 'Si è verificato un errore inatteso. Prova di nuovo.',
        type: 'error',
        showConfirmButton: true
    });
}